
import { NavLink } from "react-router-dom";
import {
  MapPin,
  Mail,
  Phone,
  ChevronRight,
} from "lucide-react";

import "./Footer.css";
import FloatingContactButtons from "../pages/FloatingContactButtons";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="footer">
        <div className="footer-container">

          {/* Company Information */}
          <div className="footer-column footer-about">
            <h2>SHREE BRAINS</h2>
            <div className="footer-title-line"></div>

            <p>
              We provide E-commerce Solutions, Order Management
              Systems, SMS, Email, WhatsApp Business API, and
              Business Automation services to help businesses
              grow digitally.
            </p>

            {/* Social Media */}
            <div className="footer-social">
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <span className="social-text">in</span>
              </a>

              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <span className="social-text">◎</span>
              </a>

              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <span className="social-text">f</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column footer-links">
            <h3>Quick Links</h3>
            <div className="footer-title-line"></div>

            <ul>
              <li>
                <NavLink to="/">
                  <ChevronRight size={16} />
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink to="/about">
                  <ChevronRight size={16} />
                  About
                </NavLink>
              </li>

              <li>
                <NavLink to="/services">
                  <ChevronRight size={16} />
                  Services
                </NavLink>
              </li>

              <li>
                <NavLink to="/contact">
                  <ChevronRight size={16} />
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="footer-column footer-contact">
            <h3>Contact Us</h3>
            <div className="footer-title-line"></div>

            <div className="contact-item">
              <MapPin className="contact-icon" size={21} />
              <span>New Delhi, India</span>
            </div>

            <div className="contact-item">
              <Mail className="contact-icon" size={21} />
              <a href="mailto:info@shreebrains.com">
                info@shreebrains.com
              </a>
            </div>

            <div className="contact-item">
              <Phone className="contact-icon" size={21} />
              <a href="tel:+919971815737">
                +91 99718 15737
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-container">
            <div className="footer-legal-links">
              <NavLink to="/terms-and-conditions">
                Terms &amp; Conditions
              </NavLink>

              <span>|</span>

              <NavLink to="/privacy-policy">
                Privacy Policy
              </NavLink>
            </div>

            <p>
              © {currentYear} SHREE BRAINS. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>

      <FloatingContactButtons />
    </>
  );
};

export default Footer;